import GenderDropdown from './GenderDropdown'

export default GenderDropdown
export { DEFAULT_TITLE as GENDER_TITLE } from './GenderDropdown'
